import type { AutoSizeValue } from '@elfsight/configurator-contracts';

export function parseWidth(value: string | number | AutoSizeValue) {
  if (value === 'auto') {
    return '100%';
  }

  if (value && typeof value === 'object') {
    return value.auto ? '100%' : `${value.customValue}px`;
  }

  if (typeof value === 'number' || Number(value)) {
    return `${value}px`;
  }

  return value;
}
